import { MeldingType } from '../interfaces';

export const getMeldingtypeFromId = (meldingstyper: MeldingType[], typeid: string): MeldingType | void => {
  if (meldingstyper) {
    return meldingstyper?.find((e: MeldingType) => e.meldingstypeId === typeid);
  }
};
